import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

/**
 *  Bar component that displays ordinal scale information in segments of 3 or 5
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const threeTiers = ['low', 'medium', 'high'];
const fiveTiers = ['poor', 'fair', 'good', 'great', 'excellent'];
function MeterBar(_ref) {
  let {
    className,
    barCount,
    uiContext = 'default',
    value,
    theme = 'brand'
  } = _ref;
  const tiers = barCount === 3 ? threeTiers : fiveTiers;

  // exclude inverse from status until colors can be determined
  if (uiContext === 'inverse') {
    theme = 'brand';
  }
  let currentTierLevel = 0;
  let currentTierDescription;
  if (typeof value === 'string') {
    const tierIndex = tiers.findIndex(tier => tier === value);
    currentTierLevel = tierIndex + 1;
    currentTierDescription = tiers[tierIndex];
  } else if (typeof value === 'number' && value > 0) {
    currentTierLevel = value;
    currentTierDescription = tiers[value - 1];
  }
  const percentageFilled = currentTierLevel * 100 / tiers.length;
  const lowStatus = percentageFilled < 40;
  const mediumStatus = percentageFilled < 70 && percentageFilled >= 40;
  const highStatus = percentageFilled >= 70;
  const classNames = clsx('meter-bar', {
    'meter-bar-inverse': uiContext === 'inverse',
    'meter-bar-status-low': theme === 'status' && lowStatus,
    'meter-bar-status-med': theme === 'status' && mediumStatus,
    'meter-bar-status-high': theme === 'status' && highStatus
  }, className);
  const minWidthValue = tiers.length > 0 && tiers.length * 16;
  const renderSegments = (tier, index) => {
    const isFilled = index + 1 <= currentTierLevel;
    const segmentClassNames = clsx('meter-bar-segment', {
      'segment-filled': isFilled
    });
    return /*#__PURE__*/_jsx("div", {
      className: segmentClassNames
    }, tier);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classNames,
    "data-cmp": "meterBar",
    style: {
      minWidth: minWidthValue
    },
    children: [/*#__PURE__*/_jsx("span", {
      className: "sr-only",
      children: `graphic with value of "${currentTierDescription}" (${currentTierLevel} out of ${tiers.length}) `
    }), tiers.map(renderSegments)]
  });
}
export default MeterBar;